import cn from 'classnames'
import React from 'react'
import AuctionAssetPreview from '../assetpreview/AuctionAssetPreview'

export const AuctionList = (props) => {
    const assets = props['assets']
    const id = props['id']
    const page = props['page']
    const selectable = props['selectable']
    const searchOwner = props['searchOwner']

    return (
        <div className={'w-full h-auto mb-4 mt-4'}>
            <div
                className={cn(
                    'grid sm:gap-4 gap-2 grid-cols-1 xsse:grid-cols-2 sm1:grid-cols-3 md:grid-cols-3',
                    'md1:grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 3xl:grid-cols-7 4xl:grid-cols-7',
                    'text-center sm:mx-4 mx-2',
                )}
                id={id ? id : ''}
            >
                {assets?.map((asset, index) => (
                    <AuctionAssetPreview
                        index={index}
                        key={`${asset.listingId}_${index}`}
                        auction={asset}
                        selectable={selectable}
                        searchOwner={searchOwner}
                        page={page}
                    />
                ))}
            </div>
        </div>
    )
}
